module.exports = __webpack_public_path__ + "static/media/eppt-logotype-l.2c20c797.svg";